import { ApiUrl } from "../components/Common/ApiUrl";
import httpServiceInstance from "../helper/HttpService";

export const getDashboardData = async (days) => {
  const response = await httpServiceInstance.get(
    `${ApiUrl.DASHBOARD}?days=${days}`
  );
  return response;
};


export const getRecentSignUpsData = async (days) => {
  const response = await httpServiceInstance.get(
    // `${ApiUrl.RECENT_SIGNUPS_LIST}?days=${days}`
    `${ApiUrl.RECENT_SIGNUPS_LIST}`

  );
  return response;
};
